/**
 * Temp JS for Featured Partners carousel
 */

(function() {
    'use strict';

    const swiperSlide = new Swiper('.swiper-effectSlide', {
        loop: true,
        speed: 1000,
        autoplay: {
            delay: 7000,
        },
        grabCursor: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });
})();